import { render, staticRenderFns } from "./chatsPortal.vue?vue&type=template&id=b77a3682"
import script from "./chatsPortal.vue?vue&type=script&lang=js"
export * from "./chatsPortal.vue?vue&type=script&lang=js"
import style0 from "./chatsPortal.vue?vue&type=style&index=0&id=b77a3682&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports